import { axiosGet, axiosPost } from "../../../../../react_axios/Axios";
import { INSERT_UPDATE_BRANDING_OPPORTUNITY_ACTION_TYPE, GET_BRANDING_OPPORTUNITY_DETAILS_ACTION_TYPE, headers, insertUpdateBrandingOpportunityUrl, getBrandingOpportunityDetailsUrl } from "../../../../../utils/constants";



export const insertUpdateBrandingOpportunity_action = (Remark, BrandingOpportunityList, ManualFormID, ServiceID, VendorDetails) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: parseInt(sessionStorage.getItem('sessionExhibitionID')),
            ExhRegistrationID: parseInt(sessionStorage.getItem('ExhRegistrationIDSS')) || null,
            ExhVisitorID: parseInt(sessionStorage.getItem('currentVisitorID')) || null,
            Remark: Remark,
            BrandingOpportunityList: BrandingOpportunityList,
            ManualFormID: ManualFormID,
            ServiceID: ServiceID,
            VendorDetails: VendorDetails
        }
        const res = await axiosPost(insertUpdateBrandingOpportunityUrl, params, headers)

        dispatch({
            type: INSERT_UPDATE_BRANDING_OPPORTUNITY_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getBrandingOpportunityDetails_action = () => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID') ,
            ExhRegistrationID: sessionStorage.getItem('ExhRegistrationIDSS') || null,
            ExhVisitorID: parseInt(sessionStorage.getItem('currentVisitorID')) || null,
        }
        const res = await axiosGet(getBrandingOpportunityDetailsUrl, params, headers)

        dispatch({
            type: GET_BRANDING_OPPORTUNITY_DETAILS_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}
